<aur-card
  id="card-autopay-enrollment-prompt"
  emphasis="subdued"
  class="autopay-enrollment-prompt"
>
  <h5 class="autopay-enrollment-heading">
    {{ headingKey | translate }}
    <aur-icon color="dark" emphasis="subdued" size="xs">info_outline</aur-icon>
  </h5>
  <p>{{ bodyKey | translate }}</p>
  <button
    id="btn-enroll-autopay"
    aur-button
    importance="secondary"
    (click)="enrollClicked.emit()"
  >
    {{ 'ARC_PAYMENT_AUTOPAY_ENROLLMENT_BANNER_BUTTON' | translate }}
  </button>
</aur-card>
